import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { onlyNumbers } from "src/utils/regex";

export const CustomInput = ({ setError: setParentError, ...props }: any) => {
  const [name, setName] = useState(props.value);
  const [error, setError] = useState<undefined | string>();
  const inputRef = useRef<HTMLDivElement | null>(null);

  const onChange = (e: any) => {
    e.preventDefault();
    props.onChange(e);
    const newValue = e.target.value;
    if (onlyNumbers.test(newValue) || e.target.value === "") {
      setName(newValue);
      if (setParentError) setParentError(props.error);
      setError("");
    } else {
      if (newValue) {
        setError("Should only contain numbers");
      }
    }
  };
  const helperText = props.error ?? error;
  const hasError = !!props.error ?? !!error;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <TextField
      {...props}
      autoComplete="off"
      type={"text"}
      value={name}
      onChange={onChange}
      inputProps={{
        maxLength: 6,
        style: {
          textAlign: "left",
          fontSize: "16px",
          fontWeight: 600,
          textTransform: "capitalize",
        },
      }}
      inputRef={inputRef}
      helperText={helperText}
      error={hasError}
    />
  );
};
